import type { ApolloClient } from '@apollo/client';
import { useMemo } from 'react';
import type { GetApolloClientProps } from '../lib/landsbankinnApi';
import { getLandsbankinnApolloClient } from '../lib/landsbankinnApi';

export let apolloClient: ApolloClient<any>;

export function useLandsbankinnApollo({
  initialState,
  options,
}: GetApolloClientProps) {
  // memoize the apollo client for the rest of the react render lifecycle
  return useMemo(
    () => getLandsbankinnApolloClient({ initialState, options }),
    [initialState, options],
  );
}
